export default {
    products: 'Products',
    resource: 'Product',

    id: 'ID',
    name: 'Name',
    category: 'Category',
    published_from: 'Published from',
    published_to: 'Published to',
    reviews_from: 'Reviews from',
    reviews_to: 'Reviews to',
    canonical_name: 'Canonical name',
    image: 'Image',
    images: 'Images',
    lead: 'Lead',
    slug: 'Slug',
    description: 'Description',
    price: 'Price',
    size: 'Package',
    size_input: 'Add size',
    price_input: 'Price',
    is_active: 'Active',
    is_sponsored: 'Sponsored',
    is_18_plus: 'over 18',
    published_at: 'Published',

    brand: 'Brand',
    primary_category: 'Primary Category',
    sub_category: 'Sub Category',
    sub_sub_category: 'Sub-Sub Category',
    secondary_categories: 'Secondary Categories',
    product_categories: 'Categories',
    skin_types: 'Skin Type',
    skin_concerns: 'Skin problems',
    hair_problems: 'Hair problems',
    ingredients: 'Ingredients',
    eans: 'EANs',
    sponsored_url: 'Sponsored url',
    video_url: 'Social video',

    delete: 'Delete',

    // Sections
    product: 'Product Details',
    reviews: 'Reviews',

    // Search
    is_hot: 'Hot',
    is_manufactured: 'Is Manufactured',
    sort_by: 'Sort by',
    'sortby.reviews_most': 'Most reviews',
    'sortby.reviews_least': 'Least reviews',
    'sortby.reviews_average_high': 'Average rating (High to Low)',
    'sortby.reviews_average_low': 'Average rating (Low to High)',
    'sortby.published_date_newest': 'Newest',
    'sortby.published_date_oldest': 'Oldest',
    'sortby.popularity_highest': 'Popularity (High to Low)',
    'sortby.popularity_lowest': 'Popularity (Low to High)',

    // Transfer Reviews
    select: 'Transfer to',
    copy_to: 'Copy to',

    no_ean_added: 'No EANs added',
    remove_ean: 'Remove',
    add_ean: 'Add EAN and press enter',
    add_ean_rules:
        'Press Enter to add. Only digits are allowed; typical EAN lengths: 8 or 13.',
};
